import axios from 'axios';
import altImage from '../../../img/activeLink/altImage.png';

export const insertActiveLink = async (poSDKContextState, link) => {
  try {
    const response = await axios({
      url: altImage, //your url
      method: 'GET',
      responseType: 'blob' // important
    });

    const imageBlob = new Blob([response.data]);

    await poSDKContextState.poInstance.handle.insertImage(imageBlob);
    poSDKContextState.poInstance.handle.insertHyperlink(link);
  } catch (error) {
    throw error;
  }
};
